import { useState, useEffect } from 'react';
import Link from "next/link";
import styles from './sales.module.css';
const Header = ({ active, pageTitle }) => {
    const [isActive, setIsActive] = useState(false);
    const handleMobileMenu = () => [
        setIsActive(current => !current)
    ]

    const onScroll = () => {

        let header = document.getElementById("salesNav");
        if (header) {
            let sticky = header.offsetTop;
            if (window.scrollY > sticky) {
                header.classList.add(styles.sticky);
            } else {
                header.classList.remove(styles.sticky);
            }
        }
    }

    useEffect(() => {
        window.addEventListener("scroll", onScroll);
    })

    return (
        <div className={styles.HeaderContainer} id='salesNav'>
            {
                <div className={styles.mobileNav}>
                    <span>{pageTitle}</span>
                    <div>
                        <div onClick={handleMobileMenu} className={!isActive ? styles.mobileMenuOpenButton : `${styles.mobileMenuOpenButton} ${styles.hideMobile}`}>
                            <div></div>
                            <div></div>
                        </div>
                        <div onClick={handleMobileMenu} className={isActive ? styles.mobileMenuCloseButton : `${styles.mobileMenuCloseButton} ${styles.hideMobile}`}>
                            x
                        </div>
                    </div>
                </div>}
            <div className={isActive ? styles.NavBarSales : ` ${styles.NavBarSales} ${styles.hideMobile} `}>
                <div className={active === 'agent' ? `${styles.active} ${styles.navLinks} ${styles.hideMobile}` : styles.navLinks}>
                    <Link href={`/agent-pricing`} prefetch={false} >Agents</Link>
                </div>
                <div className={active === 'landlord' ? `${styles.active} ${styles.navLinks} ${styles.hideMobile}` : styles.navLinks}>
                    <Link href={`/landlord-pricing`} prefetch={false}>Landlords</Link>
                </div>
                {/* <div className={active === 'town' ? `${styles.active} ${styles.navLinks} ${styles.hideMobile}` : styles.navLinks}>
                    <Link href={`/sales/bids`} prefetch={false}>Town Centres</Link>
                </div> */}
                {/* <div className={active === 'dx' ? `${styles.active} ${styles.navLinks} ${styles.hideMobile}` : styles.navLinks}>
                    <Link href={`/data-exchange`} prefetch={false}>Data Exchange</Link>
                </div> */}
                <div className={active === 'advertise' ? `${styles.active} ${styles.navLinks} ${styles.hideMobile}` : styles.navLinks}>
                    <Link href={`/sales/advertise`} prefetch={false}>Advertise</Link>
                </div>
                
            </div>

        </div>

    )
};

export default Header;